import {
  callApiLayDanhSachLogTheoAppPaging,
}
  from "@/api/log";

const layDanhSachLogTheoAppPaging = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLogTheoAppPaging(payload)
      .then(response => {
        if (response) {
          context.commit("SET_DANH_SACH_LOG_TRONG_APP_PAGING", response.data.data);
        }
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export default {
  layDanhSachLogTheoAppPaging,
};
